import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalService } from '@app/services/modal.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-filing-claims-emails',
  templateUrl: './modal-filing-claims-emails.component.html',
  styleUrls: ['./modal-filing-claims-emails.component.scss']
})
export class ModalFilingClaimsEmailsComponent implements OnInit {

  @ViewChild('formEmail') formEmail: NgForm;
  @Output() emailEvent:EventEmitter<string> = new EventEmitter();
  public secondEmail: boolean;
  public email: SecondEmailModel = new SecondEmailModel();

  constructor(
    public modal:ModalService,
    public navigate: Router
  ) { }

  ngOnInit() {

  }

  get ifEmailIsValid() : boolean {
    if (!this.email.email || !this.email.emailConfirmation) return false;
    if (!this.validateEmail(this.email.email) && !this.validateEmail(this.email.emailConfirmation)) return false;
    if (this.email.email == this.email.emailConfirmation) return true;
    return false;
  }

  goToClaim() {
    this.emailEvent.emit(this.email.email);
    this.email = new SecondEmailModel();
    this.secondEmail = false;
    // this.navigate.navigateByUrl('/pages/reclamaciones/upload-documents-claims');
    this.modal.close();
  }

  validateEmail(email: string) {
    const exp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    return exp.test(email);
  }

}

class SecondEmailModel { 
  email:             string = '';
  emailConfirmation: string = '';
}